module.exports = "/static-assets/_next/static/images/peach-05654d8e5eb3afa17bd934c35e1c731b.png";